import { FC } from 'react'

import { ConnectionLineComponentProps, getSmoothStepPath } from '@xyflow/react'

import { GreyGrey40 } from '@sequencehq/core-components'

const ARROW_WIDTH = 7
const ARROW_HEIGHT = 14
const MARKER_ID = 'connection-line-arrow'

export const ConnectionLine: FC<ConnectionLineComponentProps> = ({
  fromX,
  fromY,
  toX,
  toY,
  fromPosition,
  toPosition
}) => {
  const [path] = getSmoothStepPath({
    sourceX: fromX,
    sourceY: fromY,
    targetX: toX - 10,
    targetY: toY,
    sourcePosition: fromPosition,
    targetPosition: toPosition,
    borderRadius: 20
  })

  return (
    <>
      <defs>
        <marker
          id={MARKER_ID}
          markerWidth={ARROW_WIDTH}
          markerHeight={ARROW_HEIGHT}
          refX={ARROW_WIDTH - 1}
          refY={ARROW_HEIGHT / 2}
          orient="auto-start-reverse"
          markerUnits="userSpaceOnUse"
          overflow="visible"
        >
          <polyline
            points={`1,2 ${ARROW_WIDTH},${ARROW_HEIGHT / 2} 1,${ARROW_HEIGHT - 2}`}
            fill="none"
            stroke={GreyGrey40}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </marker>
      </defs>
      <path
        d={path}
        fill="none"
        stroke={GreyGrey40}
        strokeWidth={1.5}
        markerEnd={`url(#${MARKER_ID})`}
      />
    </>
  )
}
